// extracted by mini-css-extract-plugin
module.exports = {"item":"_21bc1d3","link":"_15deb87","iconOnly":"_cce1efb","icon":"_27dbca8","text":"_ea4e2a9","activeLink":"_00b41e4"};